import React from "react";
import { SelectId } from "./SelectId";
import { Select } from "./Select";

const PASSOptions = [{ label: 'Live', id: 'Live' }, { label: 'TOC', id: 'TOC' }, { label: 'POC', id: 'POC' }, { label: 'None', id: '' }];



export const PanelAvailabilityStatusSelect = (props) => {
    /*console.log('PASS0', props);
    function onChange(evt) {
        console.log('PASS0 change', evt);
        props.onChange(evt);
    }*/
    return (props.valueIsId ? <SelectId  {...props} options={PASSOptions} labelField="label" /> :
        <Select {...props} options={PASSOptions} labelField="label" />);
}

// weird function, no longer needed
export const PanelAvailabilityStatusIdSelect = (props) => {
    return <PanelAvailabilityStatusSelect {...props} valueIsId={true} />;
}
